import * as PIXI from "pixi";

import Phys from "./Phys";
import Timer from "../utils/Timer";
import Game from "./Game";

export enum PartFadeType {
  ZOOM,
  FADE,
}

export type PartType =
  | "mcDebris"
  | "mcNuage"
  | "partSplatch"
  | "partLightFlip"
  | "partLightRainbow"
  | "partPaint"
  | "partAction";

function createGraphics(type: PartType): PIXI.animate.MovieClip {
  switch (type) {
    case "mcDebris":
      let mcDebris = new PIXI.animate.MovieClip();
      mcDebris.addChild(
        new PIXI.Graphics().beginFill(0xffffff).drawCircle(0, 0, 1.25).endFill()
      );
      return mcDebris;
    case "partLightFlip":
      let partLightFlip = new PIXI.animate.MovieClip();
      partLightFlip.addChild(
        new PIXI.Graphics()
          .beginFill(0xffffff)
          .drawCircle(0, 0, 10)
          .endFill()
          .beginHole()
          .drawCircle(0, 0, 1.5)
          .endHole()
      );
      return partLightFlip;
    default:
      // TODO: Add them to lib!
      // return new window.data.lib[type]();
      return createGraphics("mcDebris");
  }
}

export default class Part extends Phys {
  timer: number | null = null;
  fadeType: number = 0;
  fadeLimit: number;
  scale: number;

  // ADDON
  decal: number = -1;
  vd: number = -1;
  ec: number = -1;

  constructor(game: Game, type: PartType) {
    const part = createGraphics(type);
    part.name = type;
    super(game, part);
    this.fadeLimit = 10;
    this.scale = 100;
    // Cs.game.partList.push(this); TODO
  }

  setScale(sc: number) {
    this.scale = sc;
    this.root.scale.x = this.scale / 100;
    this.root.scale.y = this.scale / 100;
  }

  update() {
    super.update();
    if (this.vr != null) {
      this.vr *= this.frict;
      this.root.angle += this.vr * Timer.tmod;
    }
    if (this.timer != null) {
      this.timer -= Timer.tmod;
      if (this.timer < this.fadeLimit) {
        const c = this.timer / this.fadeLimit;
        switch (this.fadeType) {
          case PartFadeType.ZOOM:
            this.root.scale.x = (this.scale * c) / 100;
            this.root.scale.y = (this.scale * c) / 100;
            break;
          case PartFadeType.FADE:
          default:
            this.root.alpha = c * 100;
            break;
        }
        if (this.timer < 0) {
          this.kill();
        }
      }
    }
  }

  kill() {
    // Cs.game.partList.remove(this); TODO ?
    super.kill();
  }
}
